<template>
    <span>
        <button type="button" class="btn" @click="period = 'current'; show_dialogs.campaign_update = true">Update {{ moment().startOf('month').format('MMMM YYYY') }}</button>
        <button type="button" class="btn" @click="period = 'next'; show_dialogs.campaign_update = true">Update {{ moment().startOf('month').add(1, 'M').format('MMMM YYYY') }}</button>
        <dialog-campaign-multiupdate :show="show_dialogs.campaign_update"
                                     :selected_campaigns="selected_campaigns"
                                     :period="period"
                                     @updated="refresh"
                                     @close="show_dialogs.campaign_update = false"
        ></dialog-campaign-multiupdate>
    </span>
</template>

<script>
import DialogCampaignMultiupdate from "./parts/dialog-campaign-multiupdate";

export default {
    components: {DialogCampaignMultiupdate},
    props: [
        'selected_campaigns'
    ],
    data() {
        return {
            show_dialogs: {
                campaign_update: false
            },
            period: 'current'
        };
    },
    methods: {
        refresh() {
            this.$emit('updated');
        }
    }
}
</script>